import './styles.css';

import { logout } from 'actionCreators/auth';
import { resolveErrorStatus } from 'actionCreators/error';
import Maintenance from 'components/Shared/Error/Maintenance';
import ServerError from 'components/Shared/Error/ServerError';
import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';

import ComponentError from './ComponentError';
import Maintainance from './Maintenance';
import NotFound from './NotFound';
import { withErrorHandle } from './withErrorHandle';

interface IProps {
  error?: any;
}

interface IPropsFromConnect {
  errorRedux?: any;
  logout?: typeof logout;
}

interface IState {
  unloading: boolean;
}

class Error extends PureComponent<IPropsFromConnect & IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { unloading: false };
  }
  componentDidMount() {
    window.addEventListener('beforeunload', () => {
      // Validating if there's an error on screen
      const hasError = this.props.error || this.props.errorRedux;
      this.setState({ unloading: !hasError });
    });
  }

  render() {
    const error = this.props.errorRedux || this.props.error;
    const errorNumber = resolveErrorStatus(error);

    if (this.state?.unloading) {
      // Avoiding browser cancelled requests errors on unloading
      return null;
    }
    if (errorNumber === 401) {
      this.props.logout();
      return null;
    }

    return (
      <Fragment>
        {errorNumber === 504 && <Maintenance />}
        {errorNumber === 404 && <NotFound />}
        {!!error && errorNumber !== 504 && errorNumber !== 404 && <ServerError />}
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  errorRedux: state.error,
});

export default connect<IPropsFromConnect, {}, IProps>(mapStateToProps, { logout })(Error);

export { withErrorHandle, ComponentError, ServerError, Maintainance };
